import React, { useEffect } from 'react';
import { StylesProvider, MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { PersistGate } from 'redux-persist/integration/react';

import createStore, { history } from 'store/createStore';
import theme from 'lib/styles/theme';
import App from './App';

const { store, persistor } = createStore();

function Root(): React.ReactElement {
  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StylesProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
              <QueryParamProvider ReactRouterRoute={Route}>
                <App />
              </QueryParamProvider>
            </ConnectedRouter>
          </MuiThemeProvider>
        </StylesProvider>
      </PersistGate>
    </Provider>
  );
}

declare global {
  type IAppDispatch = typeof store.dispatch;
  type IGetState = typeof store.getState;
}

export default Root;
